import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { SnotifyService } from 'ng-snotify';
import { AuthService } from '../../../../services/auth.service';
import { CompanyService } from '../../../../services/company.service';
import { Company } from '../../../../models/company';
import { Inspection } from '../../../../models/inspection';
import { Equipment } from '../../../../models/equipment';
import { Page } from '../../../../models/paging/page';
import { EquipmentService } from '../../../../services/equipment.service';
import { ModalService } from '../../../../services/modal.service';
import { UUID } from 'angular2-uuid';
import { LocationService } from '../../../../services/location.service';
import { Category } from '../../../../models/category';
import { CategoryService } from '../../../../services/category.service';
import { InspectionService } from '../../../../services/inspection.service';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'app-individual-inspections',
  templateUrl: './individual-inspections.component.html',
  styleUrls: ['./individual-inspections.component.scss']
})
export class IndividualInspectionComponent implements OnInit {
  @ViewChild("repair_Date_Calendar", { static: false }) private calendar: Calendar;

  filter: any = {
    companyId: undefined
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));
  loading: boolean = false;
  showNewOption: boolean = true;
  showEquipment: boolean = false;
  company: Company = undefined;
  user;
  companyName: string = '';
  searchQuery: string = '';
  exam_Date;
  company_Id;
  inspection;
  authenticatorId;
  technicianId;
  triggerSubLocationUpdate: boolean = false;
  companySaveTrigger: boolean = false;
  equip: Equipment;
  selectedCategory: Category;
  page = new Page();
  rows = Array<Equipment>();
  selectedRows = Array<Equipment>();
  subLocationName: String = "";
  allRowsSelected: boolean = false;

  constructor(private authService: AuthService, private snotifyService: SnotifyService, public router: Router, public companyService: CompanyService,
    private modalService: ModalService, private locationService: LocationService, private categoryService: CategoryService, private inspectionService: InspectionService,
    public equipmentService: EquipmentService) {
    this.user = this.authService.currentUser.value;
    this.equip = new Equipment();
    this.inspection = new Inspection();
    this.page.pageNumber = 0;
    this.page.size = 10;

    this.setUpDefaultInspection();
  }



  ngOnInit(): void {
    this.loading = true;
    this.exam_Date = moment().toDate();

    this.company_Id = this.router.parseUrl(this.router.url).queryParams["id"];
    if (this.company_Id != null) {
      this.companyService.get(this.company_Id).then((c) => {
        this.company = c;
        this.companyName = c.name;
      }, (err) => {
        this.snotifyService.error("Error loading company details");
        this.loading = false;
        this.router.navigate(['']);

      });
    }
  }

  back() {
    this.router.navigate(['admin/companies/overview'], { queryParams: { id: this.company_Id } });
  }


  rebind() {
    this.page.pageNumber = 0;
    this.search();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.search(); this.search();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.search();
  }

  refreshRows() {
    for (var i = 0; i < this.rows.length; i++) {
      var row = this.rows[i];
      if (this.selectedRows.some(x => x.id === row.id))
        row.selected = true;
      else
        row.selected = false;
    }

  }

  addAlltoBasket() {
    this.loading = true;
    this.allRowsSelected = !this.allRowsSelected;
    if (!this.allRowsSelected) {
      this.selectedRows = [];
      this.refreshRows();
      this.loading = false;

    } else {
      this.equipmentService.getAllResultsForInspection(this.page, this.company_Id, this.searchQuery).then((pagedData) => {
        for (var i = 0; i < pagedData.data.length; i++) {
          var row = pagedData.data[i];
          this.addToBasket(row, 1);
        }
        this.refreshRows();
        this.loading = false;
      });

    }
  }



  search() {
    this.loading = true;
    this.showEquipment = true;
    this.showNewOption = false;
    this.equipmentService.getResultsForInspection(this.page, this.company_Id, this.searchQuery).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      this.refreshRows();
      //console.log(this.rows);
      this.loading = false;
    });
  }
  onLocationChange(value) {
    //console.log("location:");
    //console.log(value);
    if (value == undefined)
      this.equip.location_Id = undefined;
    else
      this.equip.location_Id = value.id;

  }

  onCategoryChange(value) {
    if (value == undefined)
      this.equip.category_Id = undefined;
    else {
      this.equip.category_Id = value.id;
      this.selectedCategory = value;
    }
  }
  onManufacturerChange(value) {
    if (value == undefined)
      this.equip.manufacturer_Id = undefined;
    else
      this.equip.manufacturer_Id = value.id;
  }
  onTechnicianChange(value) {
    if (value == undefined)
      this.technicianId = undefined;
    else
      this.technicianId = value.id;
  }

  onAuthenticatorChange(value) {
    if (value == undefined)
      this.authenticatorId = undefined;
    else
      this.authenticatorId = value.id;
  }

  setShowNewOption() {
    this.showNewOption = !this.showNewOption;
  }

  addToBasket(item, type) {
    if (this.selectedRows.some(x => x.id === item.id))
      return;

    item.selected = true;

    this.selectedRows.unshift(item);
  }

  removeFromBasket(item, type) {
    item.selected = false;
    var index = -1;
    for (var i = 0; i < this.selectedRows.length; i++) {
      var row = this.selectedRows[i];
      if (row.id == item.id)
        index = i;
    }
    if (index !== -1) {
      this.selectedRows.splice(index, 1);
    }

  }
  onSublocationChange(value) {
    if (value == undefined)
      this.equip.sublocation_Id = undefined;
    else
      this.equip.sublocation_Id = value.id;
  }
  onPurposeChange(value) {
    if (value == undefined)
      this.inspection.purpose_Of_Examination_Id = undefined;
    else {
      this.inspection.purpose_Of_Examination_Id = value.id;

      this.updateNextInspectionDate();
    }
  }
  openModal(id) {
    this.modalService.open(id);
  }
  cancelModal(id) {
    this.modalService.close(id);
  }

  addSublocation() {
    if (this.equip.location_Id == undefined || this.equip.location_Id == null) {
      this.snotifyService.error("Please select a location");
      return;
    }
    this.openModal('popup-sublocation-add');
  }


  saveSubLocation() {
    if (this.subLocationName == undefined || this.subLocationName == null || this.subLocationName == "") {
      this.snotifyService.error("Please enter a name");
      return;
    }
    var id = UUID.UUID();
    var sublocation = {
      id: id,
      name: this.subLocationName,
      location_Id: this.equip.location_Id,
      userId: this.user.id
    }

    this.locationService.savesublocation(sublocation).then((data) => {

      this.triggerSubLocationUpdate = !this.triggerSubLocationUpdate;
      this.subLocationName = undefined;
      this.onSublocationChange(sublocation);
      this.cancelModal('popup-sublocation-add');
    });
  }

  inspect() {
    var examDate = moment(this.exam_Date);
    if (!examDate.isValid()) {
      this.snotifyService.error("Please enter the exam date");
      return;
    }
    if (this.technicianId == null || this.technicianId == "" || this.technicianId == undefined) {
      this.snotifyService.error("Please select a engineer");
      return false;
    }

    if (this.selectedRows.length == 0) {
      this.snotifyService.error("Please select some items to inspect");
      return;
    }

    var e = this.selectedRows[0];
    console.log(e);
    console.log(e.category_Id);

    this.categoryService.get(e.category_Id).then((cat) => {
      this.selectedCategory = cat;

      if (this.inspection.safe_For_Use)
        this.inspection.next_Inspection_Date = moment(this.exam_Date).add(this.selectedCategory.inspection_Interval, 'month').toDate();
      else
        this.inspection.next_Inspection_Date = moment(this.exam_Date).toDate();

      if (this.selectedCategory.inspection_Interval == 6) {
        this.inspection.purpose_Of_Examination_Id = 1;
      } else if (this.selectedCategory.inspection_Interval == 12) {
        this.inspection.purpose_Of_Examination_Id = 2;
      } else {
        this.inspection.purpose_Of_Examination_Id = 3;
      }
      this.openModal('popup-inspection');
    })

  }

  saveEquipment() {
    //console.log(this.equip);
    if (!this.isValid())
      return;

this.selectedRows = [];
this.refreshRows();
    var examDate = moment(this.exam_Date);
    if (!examDate.isValid()) {
      this.snotifyService.error("Please enter the exam date");
      return;
    }
    if (this.technicianId == null || this.technicianId == "" || this.technicianId == undefined) {
      this.snotifyService.error("Please select a engineer");
      return false;
    }

    this.equip.id = UUID.UUID();

    this.equipmentService.add(this.equip).then((data) => {
      console.log(data.addedEquipment);
      if (data.addedEquipment != undefined) {

        for (var i = 0; i < data.addedEquipment.length; i++) {
          this.addToBasket(data.addedEquipment[i], 1);
        }
      } else {
        this.addToBasket(this.equip, 1);
      }


      this.inspection.next_Inspection_Date = moment(this.exam_Date).add(this.selectedCategory.inspection_Interval, 'month').toDate();

      if (this.selectedCategory.inspection_Interval == 6) {
        this.inspection.purpose_Of_Examination_Id = 1;
      } else if (this.selectedCategory.inspection_Interval == 12) {
        this.inspection.purpose_Of_Examination_Id = 2;
      } else {
        this.inspection.purpose_Of_Examination_Id = 3;
      }
      this.openModal('popup-inspection');
    });
  }

  isValid() {
    var valid = true;
    if (this.equip.serial_Num == undefined || this.equip.serial_Num == null || this.equip.serial_Num == '') {
      this.snotifyService.error("Please enter a Serial Number");
      valid = false;;
    }

    if (this.equip.description == undefined || this.equip.description == null || this.equip.description == '') {
      this.snotifyService.error("Please enter a description");
      valid = false;;
    }

    if (this.equip.swl == undefined || this.equip.swl == null || this.equip.swl == '') {
      this.snotifyService.error("Please enter a safe working load");
      valid = false;;
    }

    if (this.equip.category_Id == undefined || this.equip.category_Id == null) {
      this.snotifyService.error("Please select a category");
      valid = false;;
    }

    if (this.equip.location_Id == undefined || this.equip.location_Id == null) {
      this.snotifyService.error("Please select a location");
      valid = false;;
    }

    return valid;
  }
  immediateToPersonsChanged() {
    if (this.inspection.immediate_To_Persons && this.inspection.danger_To_Persons != null
      && this.inspection.danger_To_Persons != undefined && this.inspection.danger_To_Persons != '' && this.inspection.danger_To_Persons.toUpperCase() != 'NONE') {
      this.inspection.safe_For_Use = false;
    }
  }
  setUpDefaultInspection() {
    this.inspection = ({
      id: UUID.UUID(),
      first_Examination: false,
      installed_Correctly: true,
      purpose_Of_Examination_Id: 0,
      danger_To_Persons: '',
      immediate_To_Persons: false,
      become_Danger_To_Persons: false,
      repair_Date: '',
      repair: '',
      observations: '',
      safe_For_Use: true,
      next_Inspection_Date: '',
    })
  }

  saveInspection() {

    if (this.inspection.safe_For_Use == undefined) {
      this.snotifyService.error("please select if this item is safe to operate");
      return;
    }

    var equipIds = [];
    for (var i = 0; i < this.selectedRows.length; i++) {
      var row = this.selectedRows[i];
      equipIds.unshift(row.id);
    }
    this.inspection.equipmentIds = equipIds;
    this.inspection.inspected_At = moment(this.exam_Date + 'z').toDate();
    this.inspection.next_Inspection_Date = moment(this.inspection.next_Inspection_Date+ 'z').toDate();
    this.inspection.engineer_Id = this.technicianId;
    this.inspection.equipment_Id = equipIds[0];
    this.inspection.location_Id = this.selectedRows[0].location_Id;
    this.inspectionService.add(this.inspection).then((data) => {
      this.cancelModal('popup-inspection');
      this.setUpDefaultInspection();
      this.selectedRows = [];
      if(!this.showNewOption)
        this.search();
    });

  }

  updateNextInspectionDate() {

    if (this.inspection.safe_For_Use) {
      if (this.inspection.purpose_Of_Examination_Id == 1)
        this.inspection.next_Inspection_Date = moment(this.exam_Date).add(6, 'month').toDate();
      else if (this.inspection.purpose_Of_Examination_Id == 2)
        this.inspection.next_Inspection_Date = moment(this.exam_Date).add(12, 'month').toDate();
      else
        this.inspection.next_Inspection_Date = moment(this.exam_Date).add(this.selectedCategory.inspection_Interval, 'month').toDate();
    } else
      this.inspection.next_Inspection_Date = moment(this.exam_Date).toDate();

  }


  openCalendar(event: any) {
    var examDate = moment(this.inspection.repair_Date);
    if (!examDate.isValid()) {
      this.inspection.repair_Date_Date = moment().toDate();
    } else {
      this.inspection.repair_Date_Date = moment(this.inspection.repair_Date).toDate();
    }

    this.calendar.showOverlay();
    event.stopPropagation();
  }

  onCalendarChange() {
    this.inspection.repair_Date = moment(this.inspection.repair_Date_Date).format('DD/MM/yyyy')
  }
}
